import { parse } from 'date-fns';

import { DATE_FORMATS } from '@constants/general';

/**
 * Transforms date string from API into date
 * @param {string} date Registration date from API
 * @returns {Date}
 */
export const parseRegDate = date => {
  if (!date) return undefined;

  return parse(date, DATE_FORMATS.REG_PAGE.DATE_FORMAT, new Date());
};
